// extracted by mini-css-extract-plugin
export default {"accountpanel":"AccountPanel_accountpanel__BMy5l","usernameSpan":"AccountPanel_usernameSpan__kUwfe"};